// test2239
(2239 && 0);
